var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.params.data.start,"DD MMM, YYYY")))]),_vm._v(" - "),_c('br'),_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.params.data.end,"DD MMM, YYYY")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }